<template>
  <div>
    <div class="error-msg-area">
      <alert-msg v-if="customError" :error-msg="customErrorMsg" component="whatsapp-connect"/>
    </div>

    <div v-if="!enterCode" class="custom-fields whatsapp">
      <CustomFormFields
        ref="whatsappFields"
        v-model="user"
        :fields="fields"
        :base-data="baseData"
        :consent-accepted="consentAccepted"
        :show-asterisk="showAsterisk"
        @invalid="invalidEntities"
        @valid="validEntities"
      />

      <div style="position: relative">
        <button
          class="social-btn connect whatsapp"
          :style="primaryButtonStyles"
          @click.prevent="connectverify()"
        >
          <i
            v-show="baseData.flags.primaryBtnIcon || false"
            class="fa fa-wifi"
            aria-hidden="true"
          />
          {{ $t('connect') }}
        </button>
        <div
          v-show="sending || validating"
          class="sk-three-bounce"
          style="position: absolute; top: 23px; width: 100%"
        >
          <div class="sk-child sk-bounce1" />
          <div class="sk-child sk-bounce2" />
          <div class="sk-child sk-bounce3" />
        </div>
      </div>
      <a v-if="baseData.backButton" href="#" @click.prevent="goBack()">
        ← {{ $t('back_button') }}
      </a>
    </div>

    <transition name="slide-fade">
      <div v-if="enterCode && !loading && !connected" class="custom-fields">
        <div class="whatsapp-sent-holder">
          <transition name="slide-fade">
            <p v-if="sent" class="whatsapp-sent">{{ $t('success') }}</p>
          </transition>
        </div>

        <CustomFormFields
          ref="whatsappPinFields"
          v-model="pin"
          :fields="pinFields"
          :base-data="baseData"
          :pin-length="6"
          @invalid="invalidPinEntities"
          @valid="validPinEntities"
        />

        <div class="code-buttons" style="position: relative">
          <div
            v-show="sending"
            class="sk-three-bounce"
            style="position: absolute; top: 23px; width: 50%"
          >
            <div class="sk-child sk-bounce1" />
            <div class="sk-child sk-bounce2" />
            <div class="sk-child sk-bounce3" />
          </div>
          <button
            class="social-btn connect whatsapp resend-pin"
            :disabled="resendBtnDisabled"
            @click.prevent="resendWhatsApp()"
          >
            {{
              resendBtnDisabled ? $t('resend_pin') + ' ' + `${countdownTime}...` : $t('resend_pin')
            }}
          </button>
          <button class="social-btn connect connect-now" @click.prevent="verifyPin()">
            {{ $t('connect_button') }}
          </button>
        </div>
        <a href="#" @click.prevent="goBack()"> ← {{ $t('back_button') }} </a>
      </div>
    </transition>

    <div class="wifi-loader-area" style="text-align: center">
      <transition name="slide-fade">
        <div v-if="loading" class="loader">
          <wifi-loader />
          <p>{{ $t('connecting') }}</p>
        </div>
      </transition>
    </div>

    <div style="text-align: center">
      <transition name="slide-fade">
        <div v-if="connected" class="loader">
          <p>{{ $t('operation_success') }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import WifiLoader from '../../components/loader/wifi-loading'
  import AlertMsg from '../../components/errors/alert'
  import CustomFormFields from '../fields/custom-fields'
  import { logUserAction } from '../../utils/logging'

  export default {
    components: {
      WifiLoader,
      AlertMsg,
      CustomFormFields,
    },
    props: ['api', 'wftkn', 'action', 'consentAccepted', 'showAsterisk'],
    data() {
      return {
        number: '',
        sending: false,
        enterCode: false,
        resendBtnDisabled: false,
        countdownTime: 60,
        sent: false,
        user_pin: '',
        loading: false,
        connected: false,
        customError: false,
        customErrorMsg: '',
        validating: false,
        user: null,
        pin: null,
        fields: ['Phone'],
        pinFields: ['Phone PIN'],
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      payload() {
        return {
          ...this.user,
          action: 'whatsapp-verify',
          wftkn: this.wftkn,
          user_pin: this.pin.phone_pin,
        }
      },
      whatsappPayload() {
        return {
          action: this.action,
          wftkn: this.wftkn,
          ...this.user,
        }
      },
      primaryButtonStyles() {
        return {
          'border-radius': `${this.radius}px` || '32px',
          background: this.primaryButtonColor || '#25D366',
          color: this.primaryButtonTextColor || 'white',
          'justify-content': this.primaryButtonTextAlignment || 'center',
        }
      },
      radius() {
        return this.baseData.sizes.loginBtnsRadius
      },
      primaryButtonColor() {
        return this.baseData.colors.primaryBtn
      },
      primaryButtonTextColor() {
        return this.baseData.colors.primaryBtnText
      },
      primaryButtonTextAlignment() {
        return this.baseData.fonts.alignments.primaryBtn
      },
    },
    watch: {
      sent() {
        if (this.sent) {
          setTimeout(() => {
            this.sent = false
          }, 3000)
        }
      },
    },
    mounted() {
      this.getCode()
      this.getCustomFields()
    },
    methods: {
      getCustomFields() {
        if (this.baseData.loginOptions) {
          const whatsappOption = this.baseData.loginOptions.options.find(option => option.name === 'WhatsApp')
          let fieldsArray = []
          if (whatsappOption && Array.isArray(whatsappOption.fields) && whatsappOption.fields.length > 0) {
            fieldsArray = whatsappOption.fields
          } else {
            fieldsArray = ['Phone']
          }
          if (!fieldsArray.includes('Phone')) {
            fieldsArray.push('Phone')
          }
          this.fields = fieldsArray

          if (!this.consentAccepted && this.consentAccepted !== undefined) {
            this.fields = this.fields.filter((field) => field !== 'Email')
          }
        }
      },
      getCode() {
        this.code = this.baseData.advancedOptions ? this.baseData.advancedOptions.country.dialCode : '+1'
      },
      goBack() {
        logUserAction({ type: 'click', label: 'WhatsApp Go Back Link' });
        this.$eventHub.$emit('showWhatsApp', false)
      },
      resetError() {
        this.customError = false
        this.customErrorMsg = ''
      },
      resendWhatsApp() {
        logUserAction({ type: 'click', label: 'WhatsApp Resend Button' });
        this.sent = false
        this.sendWhatsApp()
        this.resendBtnDisabled = true
        const timer = setInterval(() => {
          if (this.countdownTime > 0) {
            this.countdownTime--
          } else {
            clearInterval(timer)
            this.resendBtnDisabled = false
            this.countdownTime = 60
          }
        }, 1000)
        this.sent = true
      },
      connectverify() {
        logUserAction({ type: 'click', label: 'WhatsApp Connect Button' });
        if (!this.api.includes('preview')) {
          this.validating = true
          this.$refs.whatsappFields.allValid()
        }
      },
      invalidEntities() {
        this.validating = false
      },
      validEntities() {
        this.validating = false
        this.sendWhatsApp()
      },
      sendWhatsApp() {
        this.resetError()
        this.sending = true
        axios
          .post(
            this.api + '&action=' + this.whatsappPayload.action,
            qs.stringify(this.whatsappPayload),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
          )
          .then(
            (res) => {
              this.sending = false
              if (!res.data.status) {
                this.enterCode = false
                this.customError = true
                this.customErrorMsg = res.data.message
              } else {
                this.enterCode = true
                this.user_phone = res.data.user_phone
              }
            },
            (res) => {
              if (res.response.data.url) {
                window.location.href = res.response.data.url
              }
              this.sending = false
              this.enterCode = false
              this.customError = true
              this.customErrorMsg = res.response.data.message
            },
          )
      },
      verifyPin() {
        logUserAction({ type: 'click', label: 'WhatsApp Verify Pin Button' });
        this.$refs.whatsappPinFields.allValid()
      },
      invalidPinEntities() {
        this.loading = false
      },
      validPinEntities() {
        this.loading = true
        this.connect()
      },
      async connect() {
        this.resetError()
        try {
          const response = await axios.post(
            this.api + '&action=' + this.payload.action,
            qs.stringify(this.payload),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
          )
          this.loading = false
          this.connected = true
          setTimeout(() => {
            window.location = response.data.url
          }, 1000)
        } catch (error) {
          this.loading = false
          this.customError = true

          const defaultError = 'pin_error';
          if (error.response?.data?.error_message) {
            const errorMap = {
              default: defaultError,
            }
            if (errorMap[error.response.data.error_message]) {
              this.customErrorMsg = this.$t(errorMap[error.response.data.error_message])
            } else {
              this.customErrorMsg = this.$t(errorMap.default)
            }
          } else {
            this.customErrorMsg = this.$t(error.response?.data?.message || defaultError)
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .wifi-loader-area .wifi-symbol .wifi-circle {
    border-color: #25D366;
  }
  .whatsapp-sent-holder {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
  }
  .whatsapp-sent {
    background: #deffd4;
    padding: 10px;
    max-width: 270px;
    border-radius: 5px;
    margin: 0 auto;
    color: #25D366;
    text-align: center;
    position: absolute;
    z-index: 1;
    top: 17px;
  }
  .code-buttons {
    display: flex;
    max-width: 315px;
  }
  .code-buttons button:first-child {
    margin-right: 5px;
  }
  .code-buttons button:last-child {
    margin-left: 5px;
    margin-bottom: 10px;
  }
  .connect.whatsapp {
    background: #25D366;
  }
  .connect.whatsapp:hover {
    background: #1d9b4d;
  }
  .whatsapp {
    .phone-code {
      display: flex;
      max-width: 320px;
    }
    .phone-code .country-code {
      width: 30px;
      margin-right: 10px;
    }
  }
  .resend-pin {
    background: #9c9c9c !important;
  }
  .resend-pin:hover {
    background: #606160 !important;
  }
  .resend-pin:disabled {
    background: #bababa !important;
  }
  .resend-pin:disabled:hover {
    background: #bababa !important;
  }
  .connect-now {
    background: #25D366 !important;
  }
  .connect-now:hover {
    background: #1d9b4d !important;
  }
</style>
